export default "__VITE_ASSET__DIhGbiHy__"